import script from "./TransferFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferFrame.vue?vue&type=script&setup=true&lang=js"

import "./TransferFrame.vue?vue&type=style&index=0&id=34de5dd3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34de5dd3"]])

export default __exports__